import { DataSource, Layout, } from "@mcleod/components";

export abstract class LayoutCommentTypeLookup extends Layout {
    sourceCommentType: DataSource;
}
